import { render, staticRenderFns } from "./GPTAssistantsMobile.vue?vue&type=template&id=5561a4b7&scoped=true"
import script from "./GPTAssistantsMobile.vue?vue&type=script&lang=js"
export * from "./GPTAssistantsMobile.vue?vue&type=script&lang=js"
import style0 from "./GPTAssistantsMobile.vue?vue&type=style&index=0&id=5561a4b7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5561a4b7",
  null
  
)

export default component.exports